import React, { useState, useEffect, use } from 'react';
import './Profile.scss'; // Подключаем стили
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import { miniApp, useLaunchParams } from '@telegram-apps/sdk-react';
import { useNavigate, useParams } from "react-router-dom";
import { useMainButton } from '../../hooks/useMainButton';
import { FreeMode } from 'swiper/modules';
import { useBackButtonManager } from '../../contexts/BackButtonContext';
import LoaderBlock from '../../components/ui/LoaderBlock';
import api from "../../api";
import { useCurrency } from '../../contexts/CurrencyContext';
import ApiImage from '../../components/ApiImage';
import DeliveryIcon from '../../components/ui/DeliveryIcon';
import { useCart } from '../../contexts/CartContext';
import Button from '../../components/ui/Button';
import { useToast } from '../../contexts/ToastContext';
import { useUser } from '../../contexts/UserContext';

const ProfilePage = () => {
  const {
      setIsEnable,
      setIsCartOpen
    } = useCart();
  const { user, isLoading, reloadUser } = useUser();
  const { showToast } = useToast();
  const navigate = useNavigate();
  const { cny } = useCurrency();
  const launchParams = useLaunchParams();
  const _user = launchParams?.initData?.user;
  useMainButton();
  const { action, clear } = useBackButtonManager();
  const [isLoad, setIsLoad] = useState(false);
  const [fio, setFio] = useState("");
  const [city, setCity] = useState("");
  const [phone, setPhone] = useState("");

  const [groupName, setGroupName] = useState("");
  const [groupCode, setGroupCode] = useState("");
  const [loadingBtnGroup, setLoadingBtnGroup] = useState(false);

  const [group, setGroup] = useState(null);
  const [members, setMembers] = useState([]);
  const [requests, setRequests] = useState([]);
  const [isOwner, setIsOwner] = useState(false);
  const [_isLoading, _setIsLoading] = useState(true);
  const [hasGroup, setHasGroup] = useState(true);
  const [error, setError] = useState(null);

  const fetchGroup = async () => {
    try {
      
      const response = await api.get('/api/group/MeGroup');
      const data = response.data;

      if (!data) {
        setHasGroup(false);
      } else {
        setGroup({
          id: data.id,
          name: data.name,
          code: data.code
        });
        setGroupName(data.name);
        setIsOwner(data.isOwner);
        setMembers(data.members || []);
        setRequests(data.requests || [])
      }
    } catch (err) {
      setError(err);
      setHasGroup(false);
    } finally {
      _setIsLoading(false);
    }
  };

  const createGroup = async () => {
    if (!groupName.trim()) {
      return showToast(`Введите название группы`);
    }
    try {
      setLoadingBtnGroup(true);
      const response = await api.post("/api/group/CreateGroup", {
        name: groupName.trim()
      });
      _setIsLoading(true);
      showToast(`Группа успешно создана`, "info");
      fetchGroup();
      reloadUser();
    } catch (error) {
      showToast(`Ошибка при создании группы`);
      console.error("Ошибка при создании группы", error);
    } finally {
      setLoadingBtnGroup(false);
    }
  };

  const joinGroup = async () => {
    if (!groupCode.trim()) {
      return showToast(`Введите код группы`);
    }
    try {
      setLoadingBtnGroup(true);
      const response = await api.post("/api/group/JoinGroup", {
        code: groupCode.trim()
      });
      showToast(`Заявка отправлена`, "info");
      setGroupCode("");
    } catch (error) {
      console.error("Ошибка при отправке заявки", error);
      showToast(`Ошибка при отправке заявки`);
    } finally {
      setLoadingBtnGroup(false);
    }
  };

  const copy = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      showToast(`Скопировано`, "info");
    } catch (err) {
      showToast(`Ошибка при копировании`);
    }
  };

  const handleKick = async (userId) => {
    setLoadingBtnGroup(true);
    try {
      await api.post("/api/group/kick", { userId });
      fetchGroup();
      reloadUser();
      showToast(`Пользователь исключен`, "info");
    } catch (error) {
      console.error("Ошибка при удалении участника:", error);
    } finally {
      setLoadingBtnGroup(false);
    }
  };

  const handleAcceptRequest = async (requestId) => {
    setLoadingBtnGroup(true);
    try {
      await api.post("/api/group/accept", { requestId });
      showToast("Заявка принята", "info");
      fetchGroup();
      reloadUser();
    } catch (error) {
      console.error("Ошибка при принятии заявки:", error);
      showToast("Ошибка при принятии", "error");
    } finally {
      setLoadingBtnGroup(false);
    }
  };

  const handleRejectRequest = async (requestId) => {
    setLoadingBtnGroup(true);
    try {
      await api.post("/api/group/reject", { requestId });
      showToast("Заявка отклонена", "info");
      setRequests((prev) => prev.filter((r) => r.requestId !== requestId));
      fetchGroup();
      reloadUser();
    } catch (error) {
      console.error("Ошибка при отклонении заявки:", error);
      showToast("Ошибка при отклонении", "error");
    } finally {
      setLoadingBtnGroup(false);
    }
  };

  const handleLeaveGroup = async () => {
    try {
      await api.post("/api/group/leave");
      showToast("Вы вышли из группы", "info");
      setGroup(null);
      setIsOwner(false);
      setMembers([]);
      setRequests([]);
      fetchGroup();
      reloadUser();
      setGroupName("");
    } catch (error) {
      console.error("Ошибка при выходе из группы:", error);
      showToast("Ошибка при выходе", "error");
    }
  };

  const updateGroupName = async () => {
    try {
      setLoadingBtnGroup(true);
      await api.post("/api/group/update-name", { name: groupName });
      showToast("Название обновлено", "info");
      fetchGroup();
      reloadUser();
    } catch (err) {
      console.error("Ошибка при обновлении названия группы:", err);
      showToast("Ошибка при обновлении", "error");
    } finally {
      setLoadingBtnGroup(false);
    }
  };

  const deleteGroup = async () => {
    if (!window.confirm("Вы уверены, что хотите удалить группу? Это действие необратимо.")) return;
    try {
      setLoadingBtnGroup(true);
      await api.post("/api/group/delete");
      showToast("Группа удалена", "info");
      setGroup(null);
      setIsOwner(false);
      setMembers([]);
      setRequests([]);
      fetchGroup();
      reloadUser();
    } catch (err) {
      console.error("Ошибка при удалении группы:", err);
      showToast("Ошибка при удалении", "error");
    } finally {
      setLoadingBtnGroup(false);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    miniApp.setBackgroundColor('#1D1D20');
    miniApp.setHeaderColor('#1D1D20');
    setIsEnable(false);
    setIsCartOpen(false);
    
    action(() => window.history.back());
    _setIsLoading(true);
    fetchGroup();
    return () => {
      miniApp.setBackgroundColor('#1D1D20');
      miniApp.setHeaderColor('#1D1D20');
      setIsEnable(true);
      clear();
    };
  }, []);
  useEffect(() => {
    setFio(user?.fio);
    setCity(user?.city);
    setPhone(user?.phone);
  }, [isLoading]);

  const saveUserInfo = async () => {
    try {
      setLoadingBtnGroup(true);
      await api.post("/api/users/UpdateDeliveryInfo", {
        fio,
        city,
        phone
      });
      showToast("Данные успешно сохранены", "info");
      reloadUser();
    } catch (error) {
      console.error("Ошибка при сохранении данных:", error);
      showToast("Ошибка при сохранении данных", "error");
    } finally {
      setLoadingBtnGroup(false);
    }
  };

  return (
    <div className={`profile-page ${!isLoad && "page-classes"}`}>
      <div className='avatar-image-container'>
        <div className='image-container'>
          <img
            className="user-avatar"
            src={_user?.photoUrl || 'https://via.placeholder.com/38'}
            alt="User Avatar"
          />
        </div>
      </div>
      <div className='header-name'>{_user?.firstName || 'Пользователь'}</div>
      {(!_isLoading && group) && (
        <div className='badge-container'>
          <div className='badge-group'>В группе</div>
        </div>
      )}
      
      
      <div className="data-section">
        <div className="title-section big">Данные для доставки</div>
        <div className="text-section">Чтобы не вводить каждый раз после заказа. Но если нужно будет заказать какой-то заказ в другое место — не проблема.</div>
        <div className='form-box'>
          <div className="input-group">
            <input type="text" className="form-control" onChange={(e) => setFio(e.target.value)} value={fio} placeholder="ФИО" />
          </div>
          <div className="input-group">
            <input type="text" className="form-control" onChange={(e) => setCity(e.target.value)} value={city} placeholder="Город" />
          </div>
          <div className="input-group">
            <input type="text" className="form-control" onChange={(e) => setPhone(e.target.value)} value={phone} placeholder="Телефон" />
          </div>
        </div>
        <Button className='btn-primary large mt-3' onClick={saveUserInfo} load={loadingBtnGroup}>
          Сохранить
        </Button>
      </div>
      {!_isLoading && (<>
      {!group ? (
        <>
        <div className="data-section mt-3">
          <div className="title-section big">Подключится к группе</div>
          <div className="text-section">Подключитесь к уже созданной группе по коду, чтобы просматривать заказы владельца.</div>
          <div className='form-box mt-3'>
            <div className="input-group">
              <input 
                type="text"
                value={groupCode}
                onChange={(e) => setGroupCode(e.target.value)} 
                className="form-control" 
                placeholder="Введите уникальный код" />
            </div>
          </div>
          <Button onClick={joinGroup} load={loadingBtnGroup} className='btn-secondary large mt-3'>Подключится к группе</Button>
        </div>
        <div className="data-section mt-3">
          <div className="title-section big">Группа</div>
          <div className="text-section">Создайте группу, чтобы вместе просматривать заказы. При создании группы - вы автоматически становитесь её владельцем.</div>
          <div className='form-box mt-3'>
            <div className="input-group">
              <input 
                type="text"
                className="form-control"
                placeholder="Название группы"
                value={groupName}
                onChange={(e) => setGroupName(e.target.value)} />
            </div>
          </div>
          <Button onClick={createGroup} load={loadingBtnGroup} className='btn-secondary large mt-3'>Создать</Button>
        </div>
        </>
      ) : (<>
      {isOwner ? (
        <>
          <div className="data-section mt-3">
            <div className="title-section big">Группа {group.name}</div>
            <div className='form-box mt-3'>
              <div className="form-title">Уникальный код</div>
              <div className="input-group">
                <input type="text" style={{cursor: "pointer"}} onClick={() => {copy(group.code)}} readOnly value={group.code} className="form-control" placeholder="Загрузка..." />
              </div>
            </div>
          </div>
          <div className="data-section mt-3">
            <div className="title-section big">Участники</div>
            <div className='list-group mt-3'>
              <table>
                <tbody>
                  {members?.filter(m => m != null).map((member) => {
                    const memberId = member?.id;
                    if (!memberId) return null; // пропускаем битые записи

                    return (
                      <tr key={memberId}>
                        <td>{member.fullName || "Без имени"}</td>
                        <td>
                          {user?.id && memberId !== user.id && (
                            <Button
                              className='btn-secondary mt-3'
                              load={loadingBtnGroup}
                              onClick={() => handleKick(memberId)}
                            >
                              Выгнать
                            </Button>
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
          <div className="data-section mt-3">
            <div className="title-section big">Заявки в группу</div>
            {requests.length > 0 ? (
              <div className='list-group'>
              <table>
                <tbody>
                  {requests.map((request) => (
                    <tr key={request.requestId}>
                      <td>{request.fullName}</td>
                      <td>
                        <Button className='btn-primary mt-3' load={loadingBtnGroup} onClick={() => handleAcceptRequest(request.requestId)}>
                          Принять
                        </Button>
                      </td>
                      <td>
                        <Button className='btn-secondary mt-3' load={loadingBtnGroup} onClick={() => handleRejectRequest(request.requestId)}>
                          Отклонить
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            ) : (
              <div className='no-request'>Заявок нет</div>
            )}
          </div>
          <div className="data-section mt-3">
            <div className="title-section big">Настройки группы</div>
            <div className='form-box mt-3'>
              <div className="input-group">
                <input 
                  type="text"
                  className="form-control"
                  placeholder="Название группы"
                  value={groupName}
                  onChange={(e) => setGroupName(e.target.value)} />
              </div>
            </div>
            <Button onClick={updateGroupName} load={loadingBtnGroup} className='btn-primary large mt-3'>
              Обновить название
            </Button>

            <Button onClick={deleteGroup} load={loadingBtnGroup} className='btn-secondary large mt-3'>
              Удалить группу
            </Button>
          </div>
        </>
      ) : (
        <div className="data-section mt-3">
          <div className="title-section big">Группа</div>
          <div className="text-section">Вы состоите в группе {group.name}</div>
          <Button className='btn-secondary large mt-3' onClick={handleLeaveGroup}>
            Выйти из группы
          </Button>
        </div>
      )}
      </>)}
      </>)}
    </div>
  );
};

export default ProfilePage;
